import { createFileRoute } from "@tanstack/react-router"
import { CompaniesPage } from "@/features/companies/companies-page"
import { validateListSearch } from "@/features/list-search"
export const Route = createFileRoute("/_authenticated/companies/pending")({
    validateSearch: validateListSearch,
    component: () => <CompaniesPage pending />,
})
